import { Facebook, Instagram, Linkedin, Mic2 } from "lucide-react";
import { Link } from "react-router-dom";
import { GlobalFooter } from "./GlobalFooter";

const seoPages = [
  { to: "/stand-up-dla-firm", label: "Stand-up dla firm" },
  { to: "/komik-na-event", label: "Komik na event" },
  { to: "/wystep-komediowy-na-integracje", label: "Występ na integrację" },
  { to: "/stand-up-na-konferencje", label: "Stand-up na konferencję" },
  { to: "/komik-na-impreze-firmowa", label: "Komik na imprezę firmową" },
  { to: "/wystep-komediowy-na-gale", label: "Występ na galę" },
  { to: "/stand-up-team-building", label: "Stand-up team building" },
  { to: "/komik-na-wesele", label: "Komik na wesele" },
  { to: "/wystep-komediowy-cennik", label: "Cennik występów" },
  { to: "/roast-firmowy", label: "Roast firmowy" },
  { to: "/komik-warszawa", label: "Komik Warszawa" },
  { to: "/komik-krakow", label: "Komik Kraków" },
  { to: "/komik-wroclaw", label: "Komik Wrocław" },
  { to: "/wystep-komediowy-wigilia-firmowa", label: "Wigilia firmowa" },
  { to: "/komik-na-jubileusz-firmy", label: "Jubileusz firmy" },
  { to: "/stand-up-po-angielsku", label: "Stand-up po angielsku" },
  { to: "/wystep-komediowy-na-szkoleniu", label: "Występ na szkoleniu" },
  { to: "/komik-na-urodziny", label: "Komik na urodziny" },
  { to: "/komik-poznan", label: "Komik Poznań" },
  { to: "/komik-gdansk", label: "Komik Gdańsk" },
  { to: "/komik-katowice", label: "Komik Katowice" },
  { to: "/komik-lodz", label: "Komik Łódź" },
  { to: "/komik-lublin", label: "Komik Lublin" },
  { to: "/wystep-komediowy-online", label: "Występ online" },
  { to: "/komik-na-wieczor-kawalerski", label: "Wieczór kawalerski" },
  { to: "/komik-na-event-marketingowy", label: "Event marketingowy" },
  { to: "/stand-up-na-bankiet", label: "Bankiet firmowy" },
  { to: "/komik-na-otwarcie-firmy", label: "Otwarcie firmy" },
  { to: "/wystep-na-spotkaniu-firmowym", label: "Spotkanie firmowe" },
  { to: "/komik-na-sylwestra", label: "Sylwester firmowy" },
  { to: "/stand-up-dzien-kobiet", label: "Dzień Kobiet" },
  { to: "/wystep-komediowy-konferencja-it", label: "Konferencja IT" },
  { to: "/komik-na-piknik-firmowy", label: "Piknik firmowy" },
  { to: "/stand-up-zakonczenie-roku", label: "Zakończenie roku" },
];

export const Footer = () => {
  return (
    <footer className="bg-primary text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-xl bg-brand-purple flex items-center justify-center">
                <Mic2 className="w-5 h-5 text-white" />
              </div>
              <span className="font-montserrat font-bold text-xl">WystepKomediowy.pl</span>
            </div>
            <p className="text-gray-400 leading-relaxed text-sm">
              Profesjonalne występy komediowe dla firm,
              które łączą ludzi i budują pozytywną atmosferę.
            </p>
          </div>
          <div className="text-center">
            <h4 className="font-montserrat font-bold text-lg mb-4">Kontakt</h4>
            <div className="space-y-2 text-sm">
              <p className="text-gray-400">
                Email: <a href="mailto:kontakt@wystepkomediowy.pl" className="text-brand-purple-light hover:text-brand-purple transition-colors">kontakt@wystepkomediowy.pl</a>
              </p>
              <p className="text-gray-400">Tel: +48 533 333 993</p>
            </div>
          </div>
          <div className="text-center md:text-right">
            <h4 className="font-montserrat font-bold text-lg mb-4">Social Media</h4>
            <div className="flex gap-3 justify-center md:justify-end">
              <a href="#" className="w-10 h-10 rounded-xl bg-white/5 hover:bg-brand-purple/20 flex items-center justify-center transition-all duration-300">
                <Facebook size={18} className="text-gray-400" />
              </a>
              <a href="#" className="w-10 h-10 rounded-xl bg-white/5 hover:bg-brand-purple/20 flex items-center justify-center transition-all duration-300">
                <Instagram size={18} className="text-gray-400" />
              </a>
              <a href="#" className="w-10 h-10 rounded-xl bg-white/5 hover:bg-brand-purple/20 flex items-center justify-center transition-all duration-300">
                <Linkedin size={18} className="text-gray-400" />
              </a>
            </div>
          </div>
        </div>

        {/* SEO Subpages Grid */}
        <div className="border-t border-white/10 pt-8 mb-8">
          <h4 className="font-montserrat font-bold text-sm text-gray-400 uppercase tracking-wider mb-4 text-center">Nasze usługi</h4>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 text-center">
            {seoPages.map((page) => (
              <Link
                key={page.to}
                to={page.to}
                className="text-gray-400 hover:text-brand-purple-light transition-colors text-xs py-1.5 px-2 rounded-lg hover:bg-white/5"
              >
                {page.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 mb-6">
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/rodo" className="text-gray-400 hover:text-brand-purple-light transition-colors">Obowiązek informacyjny RODO</Link>
            <span className="text-gray-600">|</span>
            <Link to="/polityka-prywatnosci" className="text-gray-400 hover:text-brand-purple-light transition-colors">Polityka prywatności</Link>
            <span className="text-gray-600">|</span>
            <Link to="/regulamin" className="text-gray-400 hover:text-brand-purple-light transition-colors">Regulamin serwisu</Link>
          </div>
        </div>

        <GlobalFooter />
      </div>
    </footer>
  );
};
